import _ from 'lodash';

import {
  EMPTY_VALUE_PLACEHOLDER,
  MISMO_FORM_FIELD,
  MismoChangeType,
} from './ImportMismoIntoLoanModal.constants';

const tagChanges = (changes, changeType) =>
  (changes ?? []).map(change => ({ ...change, changeType }));

export const buildMismoChangeSections = preview => {
  const taggedChanges = [
    ...tagChanges(preview?.added, MismoChangeType.ADDED),
    ...tagChanges(preview?.updated, MismoChangeType.UPDATED),
    ...tagChanges(preview?.removed, MismoChangeType.REMOVED),
  ];

  return Object.entries(_.groupBy(taggedChanges, 'section')).map(([section, changes]) => ({
    section,
    changes,
  }));
};

export const getSectionMetaText = changeCount =>
  `${changeCount} ${changeCount !== 1 ? 'changes' : 'change'}`;

export const getChangeRowKey = change => `${change.section}::${change.field}::${change.changeType}`;

export const formatChangeValue = value =>
  _.isNil(value) || value === '' ? EMPTY_VALUE_PLACEHOLDER : value;

export const buildMismoFormData = file => {
  const formData = new FormData();

  formData.append(MISMO_FORM_FIELD, file);

  return formData;
};
